export enum AttendeeEvent {
  CREATED = 'TL_ATTENDEE_CREATED',
  UPDATED = 'TL_ATTENDEE_UPDATED',
  DELETED = 'TL_ATTENDEE_DELETED',
}

export enum AttendeeMatchState {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
